// Общий формат для всех полей с телефоном в приложении - казахстанский номер
// это +7 и 10 цифр.

// Люди часто набирают номер с 8 (внутренний префикс) вместо +7, либо код
// страны без плюса ("7..."). Нормализуем оба варианта по мере ввода.
export function normalizePhoneInput(value: string): string {
  if (/^8\d/.test(value)) return `+7${value.slice(1)}`;
  if (/^7\d/.test(value)) return `+${value}`;
  return value;
}

export function isValidKzPhone(value: string): boolean {
  return /^\+7\d{10}$/.test(value.replace(/[\s-]/g, ""));
}
